/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../services/Authentication";
import FormButton from "../controls/buttons/FormButton";
import Attachment from "../../assets/attach.png";
import moment from "moment";
import "moment/locale/pt-br";

import file from "../../assets/file.png";
import image from "../../assets/image.png";
import video from "../../assets/video.png";
import close from "../../assets/close.png";
import AttachFile from "@material-ui/icons/AttachFile";
import EmojiEmotions from "@material-ui/icons/EmojiEmotionsOutlined";
import document from "../../assets/svg/attach.svg";
import emoji from "../../assets/svg/smile.svg";
import IconButton from "@material-ui/core/IconButton";

import app from "../../services/base.js";
import Close from "@material-ui/icons/Close";
import SendIcon from "../../assets/SendIcon.png";
import Image from "@material-ui/icons/Image";
import Video from "@material-ui/icons/Videocam";
import { withStyles } from "@material-ui/core/styles";
import Doc from "@material-ui/icons/InsertDriveFile";
import { generateUniqueFirestoreId } from "../../utils/math.js";
import { formatedMentions, maxTextLength } from "../../utils/formatters.js";
import { useDetectOutsideClick } from "./useDetectOutsideClick";

import Picker from "emoji-picker-react";
import "./ChatForm.scss";
import DynamicInput from "../DynamicInput/DynamicInput";

const isMessageEmpty = (textMessage) => {
  return adjustTextMessage(textMessage).length === 0;
};
const adjustTextMessage = (textMessage) => {
  return textMessage.trim();
};
const styles = () => ({
  colorDefault: {
    backgroundColor: "#2a558e",
    borderRadius: " 100%",
    gridRow: "span 2",
    width: 48,
    height: 48,
  },
  colorDefault: {
    backgroundColor: "#2a558e",
  },
  primary: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 15,
    color: "#303030",
  },
  secondary: {
    color: "#303030",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
  },
});

const ChatForm = ({
  selectedConversation,
  messageListRef,
  targetToReply,
  showReplyView,
  classes,
  displayReplyView = () => {},
  fileFromDrop = null,
  setFileFromDrop,
}) => {
  const [textMessage, setTextMessage] = useState("");
  const disableButton = isMessageEmpty(textMessage);
  let formContents = null;
  let handleFormSubmit = null;
  const { currentUser } = useContext(AuthContext);
  const [targetConversation, setTargetConversation] = useState({});
  const textareaRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const showDropDown = () => setIsActive(!isActive);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(false);
  const [suggestions, setSuggestions] = useState();
  const [showEmojiesPicker, setShowEmojiesPicker] = useState(false);
  moment.locale("pt-br");

  const style = {
    maxHeight: "75px",
    minHeight: "38px",
    minWidth: "300px",
    resize: "none",
    padding: "9px",
    boxSizing: "border-box",
    fontSize: "15px",
    fontFamily: "Open Sans",
  };
  useEffect(() => {
    if (fileFromDrop) {
      _handleImageChange(null, fileFromDrop);
    }
  }, [fileFromDrop]);
  useEffect(() => {
    setTextMessage("");
    if (selectedConversation && currentUser.id) {
      setLoading(true);
      if (selectedConversation.chatType !== "GroupChat") {
        setSuggestions([]);
        let targetUser =
          selectedConversation.sender === currentUser.id
            ? selectedConversation.receiverUser
            : selectedConversation.senderUser;
        targetUser.id =
          selectedConversation.sender === currentUser.id
            ? selectedConversation.receiver
            : selectedConversation.sender;
        targetUser.project =
          selectedConversation.sender === currentUser.id
            ? selectedConversation.receiverProject
            : selectedConversation.senderProject;
        setTargetConversation(() => ({
          title: `${targetUser.firstName} ${targetUser.lastName}`,
          id: targetUser.id,
          ...targetUser,
          connectionId: selectedConversation.id,
          eventId: selectedConversation.eventId,
        }));
      } else {
        setTargetConversation({
          ...selectedConversation.groupInfo,
          connectionId: selectedConversation.id,
          id: selectedConversation.groupInfo.groupOwnerId,
          eventId: selectedConversation.eventId,
        });
        getAttenders();
      }
      setLoading(false);
    }
  }, [selectedConversation, currentUser.id]);

  async function getAttenders() {
    const event = await app
      .firestore()
      .collection("events")
      .doc(selectedConversation.eventId)
      .get();
    let suggestions = event
      .data()
      .attenders.filter(
        (attender) =>
          attender.id !== currentUser.id &&
          selectedConversation.users.includes(attender.id)
      )
      .map((attender) => {
        return {
          ...attender,
          display: `${attender.firstName || ""} ${attender.lastName || ""}`,
        };
      });

    suggestions = [
      {
        id: "grupo",
        name: "grupo",
        firstName: "grupo",
        lastName: "",
        everyone: true,
        display: "grupo",
      },
      ...suggestions,
    ];
    suggestions.sort((a, b) => a.id - b.id);
    setSuggestions(suggestions);
  }
  async function sendChatMessage(
    currentUser,
    chatInfo,
    textMessage = "",
    eventId = "",
    data = undefined
  ) {
    try {
      const _id = generateUniqueFirestoreId();
      var chat = {
        _id,
        text: textMessage,
        user: {
          _id: currentUser.id,
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          photoURL: currentUser.photoURL,
        },
        targetUserId: chatInfo.id,
        eventId,
        createdAt: new Date(),
        userSeen: [currentUser.id, chatInfo.id],
      };

      if (showReplyView) {
        chat.isReply = true;
        chat.reply = {
          replyTo: `${targetToReply.user.firstName} ${targetToReply.user.lastName}`,
          replyMsg: targetToReply.text,
          _id: targetToReply._id,
          attachment: targetToReply.attachment || null,
        };
        displayReplyView(false, {});
      }
      if (data) {
        chat.attachment = {
          name: data.file.name,
          bucketPath: `${chatInfo.connectionId}/chat/${_id}`,
          pending: true,
          remoteThumbnailUrl: null,
          contentType: data.file.type.includes("image")
            ? "image"
            : data.file.type.includes("video")
            ? "video"
            : "docs",
          mimeType: data.file.type,
          size: data.file.size,
          type: data.file.type,
        };
        chat.attachment.remoteUrl = await data.reference.getDownloadURL();
      }
      let connectionRef = app
        .firestore()
        .collection("connections")
        .doc(chatInfo.connectionId);

      let doc = await connectionRef.get();

      if (!doc.exists) {
        const conversationData = {
          sender: currentUser.id,
          receiver: chatInfo.id,
          accepted: true,
          eventId: selectedConversation.eventId,
          senderUser: {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            photoURL: currentUser.photoURL,
          },
          senderProject: {},
          receiverUser: {
            firstName: chatInfo.firstName,
            lastName: chatInfo.lastName,
            photoURL: chatInfo.photoURL,
          },
          receiverProject: {},
          users: [currentUser.id, chatInfo.id],
        };
        await connectionRef.set(conversationData);
        doc = await connectionRef.get();
      }

      await connectionRef
        .collection("chat")
        .add({ ...chat, users: doc.data().users || [currentUser.id] });

      await doc.ref.set(
        {
          seenMessages: (doc.data().seenMessages || []).filter(
            (id) => id !== currentUser.id
          ),
          lastAttachments: [
            ...(doc.data().lastAttachments || []),
            chat.attachment || {},
          ],
          lastMessageDate: moment().toDate().valueOf(),
        },
        { merge: true }
      );
    } catch (e) {}
  }
  function onEmojiClick(event, { emoji }) {
    setTextMessage(textMessage + emoji);
  }
  async function customOnChangeHandler() {
    app
      .storage()
      .ref(`${targetConversation.id}/chat/${generateUniqueFirestoreId()}`)
      .put(previewAttachment.file)
      .then((data) => {
        sendChatMessage(
          currentUser,
          targetConversation,
          textMessage,
          targetConversation.eventId,
          { file: previewAttachment.file, reference: data.ref }
        );
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    closeModal();
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setTextMessage("");
    setPreviewAttachment(null);
    setIsOpen(false);
  }

  function rederModalAttachment() {
    if (previewAttachment) {
      const customModalStyles = {
        content: {
          width: "100%",
          height: "100%",
          zIndex: 9999,
          gridArea: "chat-message-list",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#ededed",
        },
      };

      return (
        <div style={customModalStyles.content}>
          <div style={{ display: "flex" }}>
            <label style={{ marginLeft: "auto" }} onClick={closeModal}>
              <IconButton
                color="primary"
                aria-label="Enviar arquivos"
                component="span"
              >
                <img src={close} height={25} width={25} alt="Enviar arquivos" />
              </IconButton>
            </label>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "-webkit-fill-available",
            }}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                maxWidth: "70%",
                maxHeight: 399,
              }}
            >
              {previewAttachment.file.type.includes("image") && (
                <img
                  style={{
                    width: "100%",
                    marginTop: 50,
                    objectFit: "contain",
                    boxShadow: "rgba(219, 219, 219, 0.35) 0px 5px 15px",
                    backgroundColor: "transparent",
                  }}
                  src={previewAttachment.imagePreviewUrl}
                  alt="Imagem enviada"
                />
              )}
              {previewAttachment.file.type.includes("video") && (
                <video width="400" controls style={{ marginTop: 50 }}>
                  <source src={previewAttachment.imagePreviewUrl} />
                  Your browser does not support HTML5 video.
                </video>
              )}
              {previewAttachment.file.type.includes("application") && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "-webkit-fill-available",
                    alignSelf: "center",
                  }}
                >
                  <img
                    src={document}
                    height={150}
                    width={150}
                    style={{ alignSelf: "center", marginTop: 150 }}
                  />
                  <p style={{ fontSize: " 1.7rem", color: "#8c90b1" }}>
                    {previewAttachment.file.name}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
  }

  function onKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      handleFormSubmit(event);
    }
  }

  function onKeyPress(event) {
    if (event.key === "Enter" && event.shiftKey) {
      return false;
    }
  }

  function _handleImageChange(e, _file = null) {
    let reader = new FileReader();
    let file = _file || e.target.files[0];
    if (e) {
      e.preventDefault();
      e.target.value = "";
    }
    reader.onloadend = () => {
      setPreviewAttachment({
        file: file,
        imagePreviewUrl: reader.result,
      });
    };
    openModal();
    reader.readAsDataURL(file);
    setFileFromDrop(null);
  }

  if (selectedConversation) {
    formContents = (
      <>
        <label onClick={() => setShowEmojiesPicker(!showEmojiesPicker)}>
          {/* <IconButton color="primary" aria-label="Emojies" component="span">
            <img
              src={emoji}
              color={"primary"}
              height={25}
              width={25}
              alt="Emojies"
            />
          </IconButton> */}
           <EmojiEmotions style={{ height: 25, width: 25, color: "#0557a8", marginLeft: 10, cursor:'pointer' }}/>
        </label>
        <div title="Enviar arquivos">
          <input
            id="icon-button-image"
            type="file"
            style={{ display: "none", fontFamily: "Open Sans" }}
            onChange={(e) => {
              _handleImageChange(e);
            }}
            accept="image/*"
          />

          <input
            id="icon-button-video"
            type="file"
            style={{ display: "none", fontFamily: "Open Sans" }}
            onChange={(e) => {
              _handleImageChange(e);
            }}
            accept="video/*"
          />

          <input
            id="icon-button-file"
            type="file"
            style={{ display: "none", fontFamily: "Open Sans" }}
            onChange={(e) => {
              _handleImageChange(e);
            }}
            accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />

          <label onClick={showDropDown}>
            {/* <IconButton
              color="primary"
              aria-label="Enviar arquivos"
              component="span"
            >
              <img
                src={Attachment}
                height={25}
                width={25}
                alt="Enviar arquivos"
              />
            </IconButton> */}
            <AttachFile style={{ height: 24, width: 25, color: "#0557a8", marginLeft: 10, cursor:'pointer' }} /> 
          </label>
          <div ref={dropdownRef}>
            <div
              className={`dropup-content ${isActive ? "active" : "inactive"}`}
            >
              <label htmlFor="icon-button-image">
                <IconButton color="primary" component="span">
                  <img src={image} height={20} width={20} />
                </IconButton>
                Enviar foto
              </label>

              <label htmlFor="icon-button-video">
                <IconButton color="primary" component="span">
                  <img src={video} height={20} width={20} />
                </IconButton>
                Enviar vídeo
              </label>

              <label htmlFor="icon-button-file">
                <IconButton color="primary" component="span">
                  <img src={file} height={20} width={20} />
                </IconButton>
                Enviar documento
              </label>
            </div>
          </div>
        </div>

        <DynamicInput
          setTextMessage={setTextMessage}
          textMessage={textMessage}
          MentionsInputProps={{
            placeholder: "Digite uma mensagem",
            className: "mentions",
            multiLine: true,
            markup: "@[display](id)",
            allowSuggestionsAboveCursor: true,
            style,
            onKeyDown,
            onKeyPress,
            rows: 1,
            autoFocus: true,
          }}
          MentionsProps={{
            trigger: "@",
            data: suggestions,
            displayTransform: (id, display) => `@${display}`,
            appendSpaceOnAdd: true,
            style: { backgroundColor: "#51A6FF" },
          }}
        />
        <FormButton disabled={modalIsOpen ? false : disableButton}>
          <img src={SendIcon} className="sendButton" alt="send-button" />
        </FormButton>
      </>
    );

    handleFormSubmit = (e) => {
      e.preventDefault();

      if (modalIsOpen) {
        customOnChangeHandler(e);
      } else if (!isMessageEmpty(textMessage)) {
        setTextMessage("");
        sendChatMessage(
          currentUser,
          targetConversation,
          textMessage,
          targetConversation.eventId
        );

        if (messageListRef && messageListRef.current) {
          // const scrollHeight = messageListRef.scrollHeight;
          // const height = messageListRef.clientHeight;
          // const maxScrollTop = scrollHeight - height;
          // messageListRef.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        }
      }
    };
  }

  function renderAttachment(attachment) {
    if (attachment.type.includes("image")) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Image /> <span className={classes.secondary}> Imagem</span>
        </div>
      );
    } else if (attachment.type.includes("video")) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Video /> <span className={classes.secondary}> Vídeo</span>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Doc /> <span className={classes.secondary}> Documento</span>
        </div>
      );
    }
  }

  return (
    <>
      <div
        className="loader"
        style={{ display: !loading ? "none" : "block" }}
      ></div>
      {modalIsOpen && rederModalAttachment()}
      <form
        id="chat-form"
        style={{ background: selectedConversation ? "#EEE" : "#FFF" }}
        onSubmit={handleFormSubmit}
      >
        <>
          {showEmojiesPicker && (
            <div
              className={showEmojiesPicker ? "emojies coolclass" : "emojies"}
            >
              <div style={{ display: "flex", position: "relative" }}>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <Picker
                    onEmojiClick={onEmojiClick}
                    groupNames={{
                      smileys_people: "Carinhas felizes",
                      animals_nature: "Animais e Natureza",
                      food_drink: "Bebidas",
                      travel_places: "Viagens",
                      activities: "Atividades",
                      objects: "Objetos",
                      symbols: "Coisas",
                      flags: "Bandeiras",
                      recently_used: "Recentes",
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {showReplyView && (
            <div className={showReplyView ? "reply coolclass" : "reply"}>
              <div
                style={{ display: "flex", position: "relative", width: "100%" }}
              >
                <div
                  style={{
                    minHeight: 55,
                    maxHeight: 110,
                    width: 5,
                    backgroundColor: "#4a4a4a",
                    display: "inline-block",
                  }}
                />
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <span
                    style={{
                      color: "#404040",
                      paddingLeft: 10,
                      paddingTop: 5,
                      fontWeight: "700",
                      fontSize: 15,
                    }}
                  >{`${targetToReply.user.firstName} ${targetToReply.user.lastName}`}</span>
                  {targetToReply.text.trim().length > 0 && (
                    <span
                      style={{
                        color: "#404040",
                        paddingLeft: 10,
                        paddingTop: 5,
                        paddingBottom: 10,
                        fontSize: 15,
                      }}
                    >
                      {maxTextLength(
                        formatedMentions(targetToReply.text, currentUser.id),
                        100
                      )}
                    </span>
                  )}
                  <div style={{ paddingLeft: 10 }}>
                    {targetToReply.attachment &&
                      renderAttachment(targetToReply.attachment)}
                  </div>
                </div>
                <div
                  style={{ float: "right", paddingRight: 10 }}
                  onClick={() => displayReplyView(false, {})}
                >
                  <span>
                    <Close
                      style={{
                        fontSize: 25,
                        color: "#0256AD",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          )}
          {formContents}
        </>
      </form>
    </>
  );
};

export default withStyles(styles)(ChatForm);
